import client from "@/plugins/axios-plugin";
import Vue from "vue";

export default async function(old, newPassword, confirmPass){
    try {
        const token =  Vue.$cookies.get("token");
        if(!token) return null;
        let data = await client.put("/user/password", {
            oldPassword: old,
            newPassword: newPassword,
            confirmPassword: confirmPass
        }, {
            headers:{
                authorization: token,
            }
        })
    return data
    } catch (error) {
        
    }
    return null
}